export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-movie-2-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50">
                  西瓜影视
                </span>
              </div>
              <p className="text-sm leading-relaxed text-background-400">
                西瓜影视致力于为全球华语观众提供海量高清电影电视剧在线观看服务，支持蓝光超清画质和流畅不缓冲播放，打造极致观影体验。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                快速导航
              </h4>
              <nav className="flex flex-col gap-2.5">
                <a href="#hero" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">首页</a>
                <a href="#topics" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">热门话题</a>
                <a href="#cards" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">精选推荐</a>
                <a href="#ranking" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">热播榜单</a>
                <a href="#faq" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
              </nav>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                内容分类
              </h4>
              <nav className="flex flex-col gap-2.5">
                <a href="#media" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">动作大片</a>
                <a href="#media" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">喜剧剧场</a>
                <a href="#media" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">悬疑推理</a>
                <a href="#media" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">科幻奇幻</a>
                <a href="#media" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">纪录片</a>
              </nav>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                合作伙伴
              </h4>
              <p className="text-sm text-background-500 leading-relaxed">
                感谢各大影视内容平台对西瓜影视的支持与信赖。
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2026 西瓜影视 版权所有 | 高清不缓冲在线观看平台
            </p>
            <div className="flex items-center gap-5">
              <a href="#contact" className="text-xs text-background-500 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">联系我们</a>
              <a href="#about" className="text-xs text-background-500 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</a>
              <a href="#faq" className="text-xs text-background-500 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">帮助中心</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}